import React from 'react';
import { useApi } from '@axiom/ui';
import type { Opportunity } from '@axiom/validation';

import { TaxonomyApi } from '../../api/taxonomy-api';

export type OpportunityProfileDetailFormPracticeAreaProps = {
  opportunity: Opportunity;
};

export const OpportunityProfileDetailFormPracticeArea = ({
  opportunity,
}: OpportunityProfileDetailFormPracticeAreaProps) => {
  const [{ data: taxonomy }] = useApi(TaxonomyApi.readTaxonomy());

  const { practiceAreas } = taxonomy;

  const practiceArea = opportunity.primaryPracticeArea
    ? practiceAreas[opportunity.primaryPracticeArea]
    : null;

  return (
    <span data-test="PRACTICE_AREA">{practiceArea?.fullName ?? '--'}</span>
  );
};
